import { FinDeNavCbemDto } from '../../Models/CBEM';
import { TableColDto } from '../../Models/Table';
import { CbemService } from './cbem.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { RootScopeService } from 'src/app/core/services/root-scope.service';
import { Component, effect ,signal, Injector, runInInjectionContext } from '@angular/core';

@Component({
    selector: 'app-cbem',

    templateUrl: './cbem.component.html',
    styleUrls: ['./cbem.component.scss'],
    standalone: false,
})



export class CBEMComponent {

  readonly resRender = signal<FinDeNavCbemDto[]>([]);
  readonly colRender = signal<TableColDto[]>([]);
  readonly rowUpdate = signal<FinDeNavCbemDto[]>([]);
  readonly isLoading = signal<boolean>(false);
  readonly tableMenu = signal<boolean>(true);
  readonly rowSelection = signal<boolean>(true);
  readonly actionMenu = signal<boolean>(true);

  constructor(
    private cbemService: CbemService,
    private storageService: StorageService,
    private rootScope: RootScopeService,
    private injector: Injector,
  ) {}

  ngOnInit(): void {
    this.fetchCols();

    runInInjectionContext(this.injector, ()=> {
      effect(() => {
        const rowData = this.rowUpdate();
        if (rowData.length !== 0) {
          this.updateRow();
        }
      })
    })
  }


  /**
   * Fetches CBEM table data
   * and updates the reactive signal.
   */
  private fetchPosts() {
    this.isLoading.set(true);
    this.cbemService.getCBEM_list().subscribe((response) => {
      if (Array.isArray(response)) {
        if (response.length > 0) {
          this.resRender.set(response);
        } else {
          this.isLoading.set(false);
          this.resRender.set([]);
        }
        
      } else {
        console.error('Expected flat array but got:', response);
      }
    });

  }

  /**
   * Fetches column metadata and dynamically constructs table column definitions   *
   */
  private fetchCols() {
    this.cbemService.getCBEM_Col().subscribe((response) => {
      if (Array.isArray(response)) {
        this.colRender.set(response);
      }
    })
    this.fetchPosts();
  }

  // TODO: Add comments
  /**
   *
   *
   *
   *
   */
  private updateRow() {
    this.cbemService.updateBilling(this.rowUpdate()).subscribe({
      next: (response: any) => {
        // if (response.softDel == true) {
        //   this.resRender.update(currentData => [...currentData, response]);
        // }
        
      },
      error: (error: any) => {
        console.error('Update failed:', error);
      }
    });
  }
 }
